import { Resource } from '../shared/resource';
import { clone } from 'lodash';

export class TruckType extends Resource {
  id: string;
  name: string;
  averageTonnage: string;
  isFavorite: boolean;
  active: boolean;
  icon: string;

  url(action): string {
    return '/trucktypes/' + this.id + '/' + action;
  }

  filterOptions(options): any[] {
    options = clone(options);

    return options;
  }
}
